<template lang="html">
  <material-card
    id="filter-card"
    :title="title"
    :text="text"
    dark
    color="busie">
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <v-select
          label="Select Filter Type"
          class="filter-type-select"
          :items="filterTypes"
          v-model="filterType"/>
      </v-flex>
      <v-flex xs12 md6>
        <v-select
          class="date-filter-type"
          v-if="dateFilter"
          :items="dateFilterTypes"
          v-model="range"/>
      </v-flex>
      <v-flex xs12>
        <date-picker
          class="filter-date-input"
          v-if="dateFilter"
          :range="range"
          v-model="filterValue"/>
        <v-text-field
          class="filter-text-input"
          v-model="filterValue"
          :label="textInputLabel"
          :disabled="!filterType"
          v-else/>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <save-btn @click="save" />
      <cancel-btn @click="cancel" />
    </v-card-actions>
  </material-card>
</template>

<script>
import DatePicker from './DatePicker'
import SaveButton from './SaveButton'
import CancelButton from './CancelButton'

export default {
  components: {
    'date-picker': DatePicker,
    'save-btn': SaveButton,
    'cancel-btn': CancelButton
  },
  data: () => ({
    title: 'Filter Quotes',
    text: 'Compose your filter below',
    filterType: null,
    filterValue: null,
    filterTypes: [
      { text: 'Pickup Date', value: 'pickup' },
      { text: 'Any Stop Date', value: 'any' },
      { text: 'Organization', value: 'org' },
      { text: 'Trip Planner', value: 'planner' }
    ],
    dateFilterTypes: [
      { text: 'on', value: false },
      { text: 'between', value: true }
    ],
    range: false,
  }),
  computed: {
    dateFilter () {
      return this.filterType === 'pickup' || this.filterType === 'any';
    },
    textInputLabel () {
      if (this.filterType === 'planner') {
        return 'Planner Name'
      }
      if (this.filterType === 'org') {
        return 'Organization Name'
      }
      return 'Select a filter type'
    }
  },
  methods: {
    save () {
      const filterType = this.filterType
      const filterValue = this.filterValue
      this.$emit('save', { filterType, filterValue })
      this.filterType = null
      this.filterValue = null
    },
    cancel () {
      this.$emit('close')
      this.filterType = null
      this.filterValue = null
    },
  }
}
</script>

<style lang="css" scoped>
</style>
